// World 13 (Crucible) — third post-launch expansion world. Introduces the
// MIXER TILE mechanic: colorless tiles that get claimed by the first
// colored tile to slide into them as a blocker (see packages/engine/src/
// slide.ts applySlide). Once claimed, the mixer becomes a normal tile of
// that color and can immediately participate in chains. This is the first
// non-lock-flavoured mechanic — instead of restricting movement, it adds
// a reward layer where careful slide ordering converts neutral matter into
// chain fuel.
//
// Progression: L1-L3 are d=6 openers (mixerCount=1, 4 colors, r=3, tiles=12-13)
// that introduce the mechanic on a gentle canvas; L4-L10 climb to d=7 with
// branching 13.03 → 24.18 and 1-2 mixers per board. The d=7 ceiling matches
// W11 Keep — keeping mechanic novelty as the headline cognitive load rather
// than depth.
//
// Generator: tools/generate-parallel.mjs --world 13 (180s solver budget,
// mixerCount=1 in cfg0/cfg3, mixerCount=2 in cfg1/cfg2). Seed 0xaebce000.
// 51 candidates pooled across 4 configs in ~13668s (~3.8h walltime, 4-worker
// pool).
import type { LevelDef } from '@tessera/engine';
import { WORLD_13_GENERATED } from './world13-generated';

export const WORLD_13_LEVELS: LevelDef[] = [...WORLD_13_GENERATED];
